angular.module("ainapp")
    .controller("payrollSettingsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Payroll Settings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.load = false;
                $scope.ViewVal = 0;


                $scope.payRoll = {
                    DebitAccountId: "",
                    CreditAccountId: "",
                }

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetPayrollSettings().then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.payRoll = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.CreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.PayrollCreditAccount = {};
                    $scope.payRoll.PayrollCreditAccount.Name = data.Name;
                    $scope.payRoll.PayrollCreditAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.PayrollCreditAccount.Name == "") {
                        $scope.payRoll.PayrollCreditAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DebitAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.PayrollDebitAccount = {};
                    $scope.payRoll.PayrollDebitAccount.Name = data.Name;
                    $scope.payRoll.PayrollDebitAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.PayrollDebitAccount.Name == "") {
                        $scope.payRoll.PayrollDebitAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.LeaveSalaryCreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.LeaveSalaryCreditAccount = {};
                    $scope.payRoll.LeaveSalaryCreditAccount.Name = data.Name;
                    $scope.payRoll.LeaveSalaryCreditAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.LeaveSalaryCreditAccount.Name == "") {
                        $scope.payRoll.LeaveSalaryCreditAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.LeaveSalaryDebitAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.LeaveSalaryDebitAccount = {};
                    $scope.payRoll.LeaveSalaryDebitAccount.Name = data.Name;
                    $scope.payRoll.LeaveSalaryDebitAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.LeaveSalaryDebitAccount.Name == "") {
                        $scope.payRoll.LeaveSalaryDebitAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.GratuityCreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.GratuityCreditAccount = {};
                    $scope.payRoll.GratuityCreditAccount.Name = data.Name;
                    $scope.payRoll.GratuityCreditAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.GratuityCreditAccount.Name == "") {
                        $scope.payRoll.GratuityCreditAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.GratuityDebitAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.payRoll.GratuityDebitAccount = {};
                    $scope.payRoll.GratuityDebitAccount.Name = data.Name;
                    $scope.payRoll.GratuityDebitAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.payRoll.GratuityDebitAccount.Name == "") {
                        $scope.payRoll.GratuityDebitAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.saveCostSettings = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddPayrollSettings($scope.payRoll).then(function (response) {
                    if (response.data != null && response.data != "") {
                        toastr.success("Success");
                        $scope.Init();
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }




      }]);
 